const inFlightRequests = new Map();

export function deduplicatedRequest(key, fn) {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key); // Return ongoing request
  }

  const promise = fn().finally(() => {
    inFlightRequests.delete(key); // Clean up when done
  });

  inFlightRequests.set(key, promise);
  return promise;
}

export function generateRequestKey(url, params) {
  const paramStr = params ? JSON.stringify(params) : '';
  return `${url}?${paramStr}`;
}